// Where the transfer stack mounts (#6773): the slot `#fleet-live-transfers` directly above the
// floating Core (`components/FleetLivePip.tsx`), which claims it while it is rendered. The slot
// exists only while Fleet Live has a body; the stack keeps its cards while it is absent and
// re-mounts into the slot the moment one is claimed again. A signal, not a DOM search: nothing
// finds the floating Core through the DOM (prototype quirk 3). It holds at most one element.

import { createSignal } from 'solid-js';

const [slot, setSlot] = createSignal<HTMLElement | null>(null);

/** The slot the stack renders into now; null while none is rendered. */
export const transferSlot = slot;

/** `el` is the slot from now; the returned function gives it up (only if it is still `el`). */
export function claimTransferSlot(el: HTMLElement): () => void {
  setSlot(el);
  return () => setSlot((cur) => (cur === el ? null : cur));
}
